import { render, staticRenderFns } from "./CardPublication.vue?vue&type=template&id=4df62fb4&scoped=true&"
import script from "./CardPublication.vue?vue&type=script&lang=js&"
export * from "./CardPublication.vue?vue&type=script&lang=js&"
import style0 from "./CardPublication.vue?vue&type=style&index=0&id=4df62fb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df62fb4",
  null
  
)

/* custom blocks */
import block0 from "./CardPublication.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports